import React, { useEffect } from "react";
import AOS from "aos";
import SEO from "../../SEO";
import "./RetailPosSoftware.css";

export default function RetailPosSoftware() {
  useEffect(() => {
    AOS.init({ duration: 800, offset: 100, once: true });
  }, []);

  const features = [
    { icon: "🛒", text: "Fast Retail POS Billing System" },
    { icon: "📦", text: "Inventory Management Integration" },
    { icon: "🏷️", text: "Barcode Scanning Support" },
    { icon: "💳", text: "Multiple Payment Methods" },
    { icon: "📊", text: "Real-Time Sales Reporting" },
    { icon: "👥", text: "Customer Management System" },
    { icon: "🏬", text: "Multi-Store Support" },
    { icon: "🔐", text: "Secure Transaction System" },
  ];

  const benefits = [
    { icon: "⚡", text: "Faster Checkout Process" },
    { icon: "💰", text: "Increase Retail Sales Efficiency" },
    { icon: "📉", text: "Reduce Billing Errors" },
    { icon: "📈", text: "Better Sales Insights" },
    { icon: "🚀", text: "Boost Business Performance" },
    { icon: "🏆", text: "Enterprise-Ready System" },
  ];

  const industries = [
    { icon: "🛒", text: "Retail Stores POS System" },
    { icon: "🏪", text: "Supermarket Billing System" },
    { icon: "💊", text: "Pharmacy POS Software" },
    { icon: "👕", text: "Garments & Clothing Stores" },
    { icon: "🍔", text: "Restaurant Billing System" },
    { icon: "🏬", text: "Shopping Malls POS" },
    { icon: "🚚", text: "Wholesale Distribution" },
    { icon: "🛍️", text: "E-Commerce Retail System" },
  ];

  const faqs = [
    {
      q: "What is Retail POS software?",
      a: "Retail POS software helps businesses manage billing, sales, inventory, and customer transactions in real time.",
    },
    {
      q: "Does it support barcode scanning?",
      a: "Yes, it fully supports barcode scanning for fast checkout.",
    },
    {
      q: "Can it manage multiple stores?",
      a: "Yes, it supports multi-store and multi-branch retail management.",
    },
    {
      q: "Is it integrated with inventory system?",
      a: "Yes, it is fully integrated with inventory and ERP systems.",
    },
  ];

  return (
    <>
      <SEO
        title="Retail POS Software | Inventory & Billing System Pakistan"
        description="Advanced retail POS software for supermarkets, pharmacies, stores and retail businesses with ERP integration in Pakistan."
        url="https://mzrsoftware.com/retail-pos-software"
      />

      <div className="retail-section">
        {/* HERO */}
        <section className="hero text-center" data-aos="fade-up">
          <h1>
            Retail POS <span>Software</span>
          </h1>

          <p>
            Smart retail POS system for fast billing, inventory management,
            barcode scanning and real-time business reporting.
          </p>
        </section>

        {/* INTRODUCTION */}
        <section className="section text-center" data-aos="fade-up">
          <h2>Introduction</h2>

          <p>
            Our Retail POS Software is designed for modern retail businesses to
            handle billing, stock, sales, and customer management with speed and
            accuracy.
          </p>
        </section>

        {/* FEATURES */}
        <section className="section">
          <h2 className="text-center">Features</h2>

          <div className="grid">
            {features.map((f, i) => (
              <div
                className="card"
                key={i}
                data-aos="fade-up"
                data-aos-delay={i * 50}
              >
                <div className="icon">{f.icon}</div>
                <h3>{f.text}</h3>
              </div>
            ))}
          </div>
        </section>

        {/* BENEFITS */}
        <section className="section">
          <h2 className="text-center">Benefits</h2>

          <div className="grid">
            {benefits.map((b, i) => (
              <div className="card" key={i} data-aos="zoom-in">
                <div className="icon">{b.icon}</div>
                <h3>{b.text}</h3>
              </div>
            ))}
          </div>
        </section>

        {/* SCREENSHOTS */}
        <section className="section text-center">
          <h2>Screenshots</h2>

          <div className="grid">
            <div className="card">🛒 Retail Dashboard</div>
            <div className="card">💳 POS Billing Screen</div>
            <div className="card">📊 Sales Report Panel</div>
          </div>
        </section>

        {/* INDUSTRIES */}
        <section className="section">
          <h2 className="text-center">Industries</h2>

          <div className="grid">
            {industries.map((ind, i) => (
              <div className="card" key={i}>
                <div className="icon">{ind.icon}</div>
                <h3>{ind.text}</h3>
              </div>
            ))}
          </div>
        </section>

        {/* FAQ */}
        <section className="section">
          <h2 className="text-center">FAQs</h2>

          <div className="grid">
            {faqs.map((faq, i) => (
              <div className="card" key={i}>
                <h3>{faq.q}</h3>
                <p>{faq.a}</p>
              </div>
            ))}
          </div>
        </section>

        {/* CTA */}
        <section className="cta text-center" data-aos="fade-up">
          <h2>Upgrade Your Retail Business Today</h2>

          <p>
            Get a powerful Retail POS system with billing, inventory, barcode
            scanning and ERP integration.
          </p>

          <a href="/contact" className="btn">
            Get Free Consultation →
          </a>
        </section>
      </div>
    </>
  );
}
